import { isNull } from 'lodash-es';

const getImageBasename = function (format, width, height, crop, ratio, defaultImage) {
  const parts = [];
  if (ratio) {
    parts.push(`r${ratio.join('x')}`);
  }
  if (width) {
    parts.push(`w${width}`);
  }
  if (height) {
    parts.push(`h${height}`);
  }
  if (crop) {
    parts.push(`c${crop.join('x')}`);
  }

  const fallbackImage = (defaultImage === undefined ? window.IMAGE_ORIGINAL : defaultImage);

  const basename = parts.length > 0 ? parts.join('_') : fallbackImage;
  const extension = format ? `.${format}` : '';

  return basename + extension;
};

const getImageBucketName = function (uuid, format, width, height, crop, ratio, defaultImage) {
  return [ window.IMAGE_BUCKET_FOLDER, uuid, getImageBasename(format, width, height, crop, ratio, defaultImage) ].join('/');
};

const getImageUrl = function (uuid, format, width, height, crop, ratio, defaultImage) {
  return `${window.IMAGE_BASE_URL}/${getImageBucketName(uuid, format, width, height, crop, ratio, defaultImage)}`;
};

const checkImageExists = function (url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    if (img.complete) {
      resolve();
    }
    img.onload = () => resolve();
    img.onerror = () => reject();
  });
};

const checkThenGetImageUrl = async function (uuid, format, width, height, crop, ratio) {
  const url = getImageUrl(uuid, format, width, height, crop, ratio);
  try {
    await checkImageExists(url);
    return url;
  } catch (error) {
    const parameters = {};
    const args = {
      format, width, height, crop, ratio,
    };
    [ 'format', 'width', 'height', 'crop', 'ratio' ].forEach((key) => {
      const value = args[key] !== undefined ? args[key] : null;
      if (!isNull(value)) {
        parameters[key] = value;
      }
      return null;
    });
    return `/image/${uuid}?${new URLSearchParams(parameters)}`;
  }
};

export { getImageBasename, getImageBucketName, getImageUrl, checkImageExists, checkThenGetImageUrl };
